export default function PHP_highlight_string() {
  return (
    <div>
      <h1>PHP_highlight_string</h1>
    </div>
  );
}
